import { ComboVariant2 } from '@/models/Combo'
import { get } from '@/utils/axios'

const fetchComboVariants = async (
  variantIds: string[],
  latLng: string,
  vendorId?: string,
  campaignId?: string,
  isPrebook?: boolean,
) => {
  try {
    return await get<ComboVariant2[]>(`/hyperlocal/v1/sellable/combo/variant`, {
      latLng,
      variant_ids: variantIds.join(','),
      vendor_id: vendorId,
      campaign_id: campaignId,
      ...(isPrebook && { isprebook: true }),
    })
  } catch {
    return []
  }
}

export default fetchComboVariants
